import styled from '@emotion/styled';
import '../../../assets/colors.scss';
import { typography } from 'src/theme/typography';
const ImportantPageStyle = styled('div')`
    background: var(--white);
    border: 1px solid var(--sand-400);
    border-radius: 6px;
    padding: 32px;
    margin-bottom: 2rem;
    ${typography.bodyMd}
    color: var(--sand-700);

    .title {
        ${typography.subhead}
        margin-bottom: 24px;
    }

    ul {
        list-style: disc;
    }

    @media screen and (max-width: 767px) {
        padding: 24px;
    }
    @media print {
        break-inside: avoid;
        page-break-inside: avoid;
        margin-top: 24px;
    }
`;
export default ImportantPageStyle;
